import { MutableRefObject, useEffect } from 'react'

export default function useClickOutside(ref: MutableRefObject<HTMLElement | null>, action?: VoidFunction) {
    useEffect(() => {
        function onClickOutSide(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                action && action();
            }
        }
        document.addEventListener("mousedown", onClickOutSide);
        return () => document.removeEventListener("mousedown", onClickOutSide)
    }, [ref, action])
}
